export const followMenu= () => {

    window.addEventListener('scroll', function() {
        var scrollPosition = window.scrollY;
        let header = document.querySelector(".header");
        let techNav = document.querySelector(".tech-nav");
        if(scrollPosition > 50) {
            header.classList.add("header--follow");
            if (techNav) {
                techNav.classList.add("tech-nav--follow");
            }
        }
        else {
            header.classList.remove("header--follow");
            if (techNav) {
                techNav.classList.remove("tech-nav--follow");
            }
        }
    });
}

